/**
 * Spaces API Service
 * Handles all space-related API calls
 */

import { apiClient } from './client';
import type { Space } from '@/types';

/**
 * Service for managing spaces (salas)
 * All endpoints are under /spaces
 */
export const spacesService = {
  /**
   * Get all spaces
   * @returns Array of spaces
   */
  async getAll(): Promise<Space[]> {
    return apiClient.get<Space[]>('/spaces');
  },

  /**
   * Get a space by id
   * @param id - Space id
   * @returns Single space
   * @throws {ApiError} If space not found or server error
   */
  async getById(id: string): Promise<Space> {
    return apiClient.get<Space>(`/spaces/${encodeURIComponent(id)}`);
  },
};
